import { render } from "./AddressClarification.vue?vue&type=template&id=4e6dcfc4&scoped=true&ts=true"
import script from "./AddressClarification.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressClarification.vue?vue&type=script&setup=true&lang=ts"

import "./AddressClarification.vue?vue&type=style&index=0&id=4e6dcfc4&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6dcfc4"],['__file',"vue/ui/AddressClarification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e6dcfc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e6dcfc4', __exports__)) {
    api.reload('4e6dcfc4', __exports__)
  }
  
  module.hot.accept("./AddressClarification.vue?vue&type=template&id=4e6dcfc4&scoped=true&ts=true", () => {
    api.rerender('4e6dcfc4', render)
  })

}


export default __exports__